{
  "title": "{{team}} Roles",
  "titleUnnamed": "Roles",
  "caption": "Roles group the people on this team, like \"Camera Operator\" or \"Greeter\". A volunteer can hold several.",
  "newRolePlaceholder": "New role name",
  "addRole": "Add Role",
  "adding": "Adding...",
  "duplicateName": "This team already has a role with that name.",
  "duplicateNamed": "This team already has a role named \"{{name}}\".",
  "createFailed": "Unable to create this role right now.",
  "empty": "No roles yet. Add one above to start grouping this team.",
  "volunteers_one": "{{count}} volunteer",
  "volunteers_other": "{{count}} volunteers",
  "trainingTitle": "Training for {{role}}",
  "trainingEmpty": "No training yet. People given this role aren't assigned anything.",
  "dueInBefore": "Due in",
  "dueInAfter": "days",
  "dueInLabel": "Days to complete {{module}}",
  "stopAssigning": "Stop assigning {{module}}",
  "invalidWindow": "Each due window must be a whole number of days, from {{min}} to {{max}}.",
  "addModule": "Add a training module",
  "addModuleOption": "Add a training module…",
  "noModules": "This church has no Training Modules yet.",
  "trainingCaptionHolders_one": "Updating a role's assigned training will automatically assign the added module to the volunteer who holds this role now.",
  "trainingCaptionHolders_other": "Updating a role's assigned training will automatically assign the added module to the {{count}} volunteers who hold this role now.",
  "trainingCaptionNoHolders": "Updating a role's assigned training will automatically assign the added module to anyone who is given this role later.",
  "renameLabel": "Rename {{role}}",
  "deleteLabel": "Delete {{role}}",
  "deleteConfirm": "Delete {{role}}?",
  "deleteHolders_one": "It will be removed from {{count}} volunteer.",
  "deleteHolders_other": "It will be removed from {{count}} volunteers.",
  "deleteNoHolders": "No one holds this role.",
  "delete": "Delete",
  "deleting": "Deleting...",
  "summaryCount_one": "Assigns {{count}} training module",
  "summaryCount_other": "Assigns {{count}} training modules",
  "summaryList": "Assigns {{list}}",
  "summaryItem_one": "{{module}} ({{count}} day)",
  "summaryItem_other": "{{module}} ({{count}} days)",
  "listSeparator": ", ",
  "unknownModule": "Unknown module",
  "assignedPart_one": "{{module}} to {{count}} volunteer",
  "assignedPart_other": "{{module}} to {{count}} volunteers",
  "assignedNotice": "Assigned {{parts}}.",
  "assignedJoiner": ", and "
}
